import React from 'react';
import { IShipmentOption } from './types';
import { ShipmentIcon } from './ShipmentIcon';

interface ShipmentSelectedValueProps {
  option: IShipmentOption | undefined;
  reviewText?: string;
}

/**
 * Component for rendering the selected shipment value in the selector button
 * @param option - The shipment option to display
 * @param reviewText - Optional review status text (e.g., "Procurement Review", "Logistics Review")
 */
export const ShipmentSelectedValue: React.FC<ShipmentSelectedValueProps> = ({ option, reviewText }) => {
  if (!option) return null;

  const showReviewIndicator = option.type === 'PENDING' || option.type === 'ACTION_NEEDED';

  return (
    <div className='flex gap-6 xl:gap-8 items-center'>
      <ShipmentIcon type={option.type} status={option.status} auditStatus={option.auditStatus} />
      <div className='flex items-center gap-4 xl:gap-6'>
        <p className='text-12 xl:text-14'>{option.shipmentNumber}</p>
        {showReviewIndicator && <div className='w-4 h-4 rounded-full bg-[#DFDFDF]' />}
        {showReviewIndicator && reviewText && <p className='text-[11px] xl:text-12 text-neutral-50'>{reviewText}</p>}
        {option.status === 'SPOT_SHIPMENT' && <span className='ml-12 text-[10px] py-2 px-4 font-semibold rounded-6 bg-neutral-10 text-neutral-50'>SPOT</span>}
      </div>
    </div>
  );
};
